export enum PersonaId {
    InteriorDesigner = 'interiorDesigner',
    Particular = 'particular',
    Professional = 'professional',
    Reseller = 'reseller',
}

export default PersonaId;
